<template>
  <div class="footer">
    <div class="container">
      <a href="http://pushstart.com.br" target="_blank">
        <img src="../assets/logo_pushstart.png" class="logo" />
      </a>
      &copy;2019, PushStart.
      Todos os direitos reservados.
      "O Show da Luna" e seus personagens são propriedade da TV PinGuim.
      @2018, TV PinGuim.
    </div>
  </div>
</template>

<script>
export default {
  name: 'footer',
}
</script>

<style scoped>
.footer {
  background: #ffffff;
  padding: 1rem 0 0.8rem;
  color: #F26722;
  line-height: 1.4em;
}

.logo {
  display: block;
  margin: 0 auto 1rem;
}

@media (min-width: 576px) {
  .logo {
    float: left;
    margin-right: 1rem;
  }
}


</style>



// WEBPACK FOOTER //
// Footer.vue?7acaa264